/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClientFailureRecordFromJSON, ClientFailureRecordToJSON } from './ClientFailureRecord';
/**
 * Check if a given object implements the ClientFailuresRecentResponse interface.
 */
export function instanceOfClientFailuresRecentResponse(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('reports' in value) || value['reports'] === undefined)
        return false;
    return true;
}
export function ClientFailuresRecentResponseFromJSON(json) {
    return ClientFailuresRecentResponseFromJSONTyped(json, false);
}
export function ClientFailuresRecentResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'reports': (json['reports'].map(ClientFailureRecordFromJSON)),
    };
}
export function ClientFailuresRecentResponseToJSON(json) {
    return ClientFailuresRecentResponseToJSONTyped(json, false);
}
export function ClientFailuresRecentResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'reports': (value['reports'].map(ClientFailureRecordToJSON)),
    };
}
